<div class="menu-button-row-form">
  <div class="row">
    <div class="col-md-6">
      <ziro-select
        [fieldId]="'action'"
        [inlineLabel]="false"
        [attr.data-automation]="'menu-button-action-' + buttonKey()"
      ></ziro-select>
    </div>

    <div class="col-md-6" [hidden]="isActionOnlyButton">
      <ziro-select
        [fieldId]="'entitySearch'"
        [inlineLabel]="false"
        [attr.data-automation]="'menu-button-entitySearch-' + buttonKey()"
      ></ziro-select>
      <ziro-text
        [fieldId]="'externalPhoneNumber'"
        [inlineLabel]="false"
        [attr.data-automation]="'menu-button-externalPhoneNumber-' + buttonKey()"
      ></ziro-text>
    </div>
  </div>

  <div class="row mt-3" [hidden]="!shouldShowAnnouncementType">
    <div class="col-md-6">
      <ziro-radio
        [fieldId]="'announcementType'"
        [attr.data-automation]="'menu-button-announcementType-' + buttonKey()"
      ></ziro-radio>
    </div>

    <div class="col-md-6">
      <div [hidden]="!shouldShowAnnouncementAudio">
        <ziro-file-upload
          [fieldId]="'announcementAudio'"
          [inlineLabel]="false"
          [attr.data-automation]="'menu-button-announcementAudio-' + buttonKey()"
        ></ziro-file-upload>
        @if (greetingUploadURL() && acceptedFileTypes.includes(greetingFileExtension())) {
          <audio
            [attr.data-automation]="'greeting-audio'"
            class="mt-2 w-100"
            controls
            [src]="greetingUploadURL()"
            [title]="greetingDownloadName()"
          ></audio>
        }
      </div>

      <div [hidden]="!shouldShowAnnouncementTts">
        <ziro-textarea
          [fieldId]="'announcementTts'"
          [attr.data-automation]="'menu-button-announcementTts-' + buttonKey()"
        ></ziro-textarea>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <ziro-text
        [fieldId]="'voiceCommand'"
        [attr.data-automation]="'menu-button-voiceCommand-' + buttonKey()"
      ></ziro-text>
    </div>
  </div>
</div>
